<!-- App.vue -->
<template>
  <router-view></router-view>

  <LockscreenOverlay
    ref="lockscreenRef"
    :timeout="lockscreenTimeout"
    :countdownDuration="lockscreenCountdown"
    message="Ecran verrouillé"
    subMessage="Veuillez vous réauthentifier pour continuer"
    @locked="handleLocked"
    @unlocked="handleUnlocked"
  />
</template>

<script>
import LockscreenOverlay from '@/components/lockscreenOverlay.vue';
import { EventBus } from '@/utils/eventBus';
import { useOrgSettings } from '@/composables/useOrgSettings';

export default {
  name: 'App',
  components: {
    LockscreenOverlay,
  },
  data() {
    return {
      lockscreenTimeout: parseInt(localStorage.getItem('lockscreen_timeout')) || 1200000,
      lockscreenCountdown: parseInt(localStorage.getItem('lockscreen_countdown')) || 300000,
    };
  },
  provide() {
    // Retourner une fonction qui lit $refs au moment de l'appel,
    // évite le conflit entre data() et $refs
    return {
      lockscreen: () => this.$refs.lockscreenRef
    };
  },
  mounted() {
    useOrgSettings().applyFromStorage();

    // Écouter le verrouillage forcé depuis n'importe quel composant
    EventBus.$on('force-lock-screen', () => {
      console.log('Force lock screen event reçu');
      const ref = this.$refs.lockscreenRef;
      if (ref && ref.lock) {
        ref.lock();
      } else {
        console.warn('Lockscreen ref non disponible');
      }
    });

    // Écouter les changements de paramètres depuis la rightbar
    EventBus.$on('lockscreen-settings-changed', (data) => {
      console.log('App.vue reçoit nouvelles données:', data);

      // Mettre à jour les props réactives — le composant recevra
      // les nouvelles valeurs sans être recréé (pas de lockscreenKey++)
      this.lockscreenTimeout = data.timeoutMs;
      this.lockscreenCountdown = data.countdownMs;

      localStorage.setItem('lockscreen_timeout', data.timeoutMs);
      localStorage.setItem('lockscreen_countdown', data.countdownMs);

      // Appeler resetWithNewSettings après que Vue ait mis à jour les props
      this.$nextTick(() => {
        const ref = this.$refs.lockscreenRef;
        if (ref && ref.resetWithNewSettings) {
          ref.resetWithNewSettings(data.timeoutMs, data.countdownMs);
        }
      });
    });
  },
  beforeUnmount() {
    EventBus.$off('lockscreen-settings-changed');
    EventBus.$off('force-lock-screen');
  },
  methods: {
    handleLocked() {
      console.log('Écran verrouillé');
    },
    handleUnlocked() {
      console.log('Écran déverrouillé');
    }
  }
}
</script>

<style>
.text-bordeaux {
  color: #800000 !important;
}

/* Variables de couleurs */
:root {
  --primary-color: #1a73e8;
  --secondary-color: #34a853;
  --accent-color: #ea4335;
  --background-color: #ffffff;
  --vz-primary: #405189;
  --vz-primary-subtle: #e7ebf5;
  --vz-success: #0ab39c;
  --vz-success-subtle: #e0f5f1;
  --vz-danger: #f06548;
  --vz-danger-subtle: #fde9e7;
  --vz-warning: #f7b84b;
  --vz-warning-subtle: #fef3e5;
  --vz-info: #299cdb;
  --vz-info-subtle: #e3f0fa;
  --vz-light: #f3f6f9;
  --vz-dark: #1e293b;
  --vz-muted: #7e8794;
  --vz-card-bg: #ffffff;
  --vz-border-color: #e9ebec;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active {
  animation: fadeIn 0.3s ease;
}

/* Scrollbar personnalisée */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: var(--vz-light);
}

::-webkit-scrollbar-thumb {
  background: var(--vz-muted);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--vz-primary);
}

/* Utilitaires */
.text-purple {
  color: #7f56da;
}

.bg-purple-subtle {
  background: #f2edff;
  color: #7f56da;
}

/* Transitions */
.folder-enter-active,
.folder-leave-active {
  transition: all 0.3s ease;
}

.folder-enter-from,
.folder-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>